<template>
  <footer class="emi-index-footer">
    <div class="emi-index-footer-box">
      <p> Copyright © 2020 MIUI 京ICP备10046444号</p>
      <img alt="可信网站" src="http://s1.mi.com/zt/12052601/cnnicVerifyseal.png" width="68" height="25" />
    </div>
  </footer>
</template>
<script>
  export default {
    name: 'common-footer'
  };
</script>